import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as fn from '@/api'
import { setStorage, getStorage } from '@/util'
import { Message, MessageBox } from 'element-ui'

axios.defaults.headers.common['appVersion'] = '{"mobileOs":"android","version":"1.0.0"}'
Vue.use(Vuex)
export default new Vuex.Store({
  namespaced: true,
  state: {
    pageState: false,
    homePromotions: {},//首頁優惠
    homeInfo: {},//首頁資訊
    searchArea: [],//搜尋用地區
    jobType: [],//求職徵才分類
    jobList: [],//求職徵才列表
    jobDetail: {},//求職徵才詳情
    carType: [],//取得車輛類型
    caseType: [],//案件交流分類
    caseList: [],//案件交流列表
    caseDetail: {},//案件交流詳情
    sellType: [],//物件買賣分類
    sellList: [],//物件買賣列表
    sellDetail: {},//物件買賣詳情
    notificationList: [],//系統通知列表
    userInfo: {},//個人登入資訊
    pages: {}, //列表頁數相關,
  },
  mutations: {
    SET_TEMP_DATA(state, payload = {}) {
      state[payload.temp] = payload.data
    },
    SET_PAGES(state, payload = {}) {
      state.pages = payload
    },
    SET_STATE(state, payload = {}) {
      state.pageState = payload
    },
    setShoppingCarDrawer(state,status) {
        state.shoppingCarDrawer = status
    }
  },
  actions: {
    async AXIOS({commit}, payload) {
      const isLogin = getStorage('assessToken')
      let res
      let [method, url, data = {}, config] = payload
      if (isLogin) {
        axios.defaults.headers.common['Authorization'] = isLogin
        //統一引導錯誤訊息
        res = await axios[method](url, data, config).catch((err) => {
          Message({
            message: '連線失敗，請稍後再試或聯繫客服',
          })
          //const clearData = []
          //commit('SET_TEMP_DATA', {temp: config, clearData})
          commit('SET_STATE', false)
          return err
        })
      } else {
        //沒有token
        MessageBox.alert('登入逾時', {
          type: 'warning',
          showClose: false,
        }).then(() => (location.href = '/app/'))
        res = false
      }
      return (res || {}).data
    },
    async FETCH(action, payload) {
      const { key, ...obj } = payload
      const res = await fn[key](action, obj)
      return res
    },
    SET_TEMP_DATA({ commit }, payload) {
      commit('SET_TEMP_DATA', payload)
    }
  },
  modules: {
  },
  getters: {
    pageState: state => state.pageState,
    homePromotions: state => state.homePromotions,
    homeInfo: state => state.homeInfo,
    searchArea: state => state.searchArea,
    jobType: state => state.jobType,
    jobList: state => state.jobList,
    jobDetail: state => state.jobDetail,
    carType: state => state.carType,
    caseType: state => state.caseType,
    caseList: state => state.caseList,
    caseDetail: state => state.caseDetail,
    sellType: state => state.sellType,
    sellList: state => state.sellList,
    sellDetail: state => state.sellDetail,
    notificationList: state => state.notificationList,
    userInfo: state => state.userInfo,
    jobData: state => state.jobData,
    pages: state => state.pages
  }
})
